import { ready } from '../utils/readyinit';
import initCartUpsellAtc from '../components/cart-upsell-atc';
import initCartPage from '../sections/cart/initCartPage';
import initRelatedProducts from '../sections/product/related-products';

ready(() => {
  initCartUpsellAtc();
  initCartPage();
  initRelatedProducts({
    containerSelector: '[data-cart-related-products]',
    contentSelector: '[data-cart-related-products-content]',
    renderSelector: '[data-cart-related-render]',
    onAddSuccess: () => window.location.reload()
  });
});
